import { render, staticRenderFns } from "./HighRiskCountryPopup.vue?vue&type=template&id=23aa0440&scoped=true"
import script from "./HighRiskCountryPopup.vue?vue&type=script&lang=js"
export * from "./HighRiskCountryPopup.vue?vue&type=script&lang=js"
import style0 from "./HighRiskCountryPopup.vue?vue&type=style&index=0&id=23aa0440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa0440",
  null
  
)

export default component.exports